<ngx-backdrop #loader spinner="default" text="Please wait..." backdropClass="full">
    <div id="app-component">
        <app-side-bar [expanded]="showSideNav" (toggleMenu)="openSideNav($event)">
            <div id='app-body' sidnav-router-outlet>
                <div *ngIf="authService.isAuthenticated" class="alerts-container">
                    <!-- TODO: Uncomment this when plan alert is ready, but accordingly update the condition in the headerTopOffset method -->
                     <ng-container *ngIf="!isFromMobile">
                         <!-- <app-plan-alert (alertClosed)="showNewFeatureAlert = true" *ngIf="!hidePlansAlert && !authService.isAdminLogin"></app-plan-alert> -->
                         <app-new-feature-alert></app-new-feature-alert>
                     </ng-container>
                </div>
                <div *ngIf="authService.isAuthenticated && authService.accessTokenObj.role !== AuthRole.ADMIN && !isFromMobile" 
                     class="header-background-image"
                     [ngStyle]="{'top.px': headerTopOffset}">
                    <app-header [sideMenuOpen]="showSideNav" (toggleMenu)="openSideNav($event)" style="z-index: 2"></app-header>
                </div>

                <app-index-ticker *ngIf="authService.isAuthenticated && authService.accessTokenObj.role !== AuthRole.ADMIN && !isFromMobile"></app-index-ticker>

                <!-- <mat-sidenav-container *ngIf="authService.isAuthenticated" class="notification-sidenav"
                    [ngClass]="{'notification-height-adjust': notificationsService.isNotificationOpen}">
                    <mat-sidenav mode="over" position="end" [opened]="notificationsService.isNotificationOpen"
                                 class="width-30 border-radius-8 pad-8-bottom" (closedStart)="toggleNotificationSidenav()" [ngClass]="{'cover-height': notificationsService.isNotificationOpen}">
                        <app-notifications notificationPanel="true"></app-notifications>
                    </mat-sidenav>
                </mat-sidenav-container> -->

                <div id='router-wrapper'>
                    <router-outlet></router-outlet>
                </div>
            </div>
        </app-side-bar>

        <div class="footer flex-centered-container-vr font-12" *ngIf="!isFromMobile">
            <span class="dynamic-font">&copy; Copyright {{ appName }}</span>

            <div class="spacer"></div>

            <div class="flex-centered-container-hr width-30 align-in-col" *ngIf="!BUILD_DEALER && authService.isAuthenticated">
                <a class="decoration-none " *ngFor="let link of legalLinks" [href]="link.url" target="_blank">
                    <span class="dynamic-font margin-right no-wrap cursor-pointer">
                        {{ link.name }}
                    </span>
                </a>
            </div>

            <div class="spacer"></div>

            <span class="dynamic-font">
                Version {{frontend_version}}
            </span>

            <div class="footer-icons">
                <a *ngFor="let icon of socialIcons" [href]="icon.url" target="_blank">
                    <mat-icon [svgIcon]="icon.icon" class="margin-8-right cursor-pointer"></mat-icon>
                </a>
            </div>
        </div>
    </div>
</ngx-backdrop>